import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: grey;
  opacity: 0.9;
  padding: 20px;
  color: #fff;
  height: 1%;
  max-height: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 0.75rem;
`;

const Footer = () => {
  return (
    <FooterWrapper className='footer-wrapper'>
      <p>&copy; 2025 AdvPOS. All rights reserved.</p>
    </FooterWrapper>
  );
};

export default Footer;
